/* Trace 2.1 storefront loader — live view is transient and never recorded. */
(function loadTraceSignals() {
  'use strict';
  if (window.__TRACE_21_LOADING__) return;
  window.__TRACE_21_LOADING__ = true;

  window.TRACE_CONFIG = Object.assign({}, window.TRACE_CONFIG || {}, {
    endpoint: 'https://trace-7f4c2a9d.217.216.55.237.sslip.io/api/events',
    liveEndpoint: 'https://trace-7f4c2a9d.217.216.55.237.sslip.io/api/live-frame',
    liveView: true,
    liveIntervalMs: 4000,
    consentRequired: true,
    respectGpc: true
  });

  var script = document.createElement('script');
  script.src = 'https://trace-7f4c2a9d.217.216.55.237.sslip.io/tracker.js?v=2.1.0';
  script.async = true;
  script.dataset.traceCanonical = '2.1.0';
  document.head.appendChild(script);
})();
